/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateScreenerSettingRequest
 */
export interface UpdateScreenerSettingRequest {
    /**
     * 
     */
    value?: string;
}

/**
 * Check if a given object implements the UpdateScreenerSettingRequest interface.
 */
export function instanceOfUpdateScreenerSettingRequest(value: object): value is UpdateScreenerSettingRequest {
    return true;
}

export function UpdateScreenerSettingRequestFromJSON(json: any): UpdateScreenerSettingRequest {
    return UpdateScreenerSettingRequestFromJSONTyped(json, false);
}

export function UpdateScreenerSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function UpdateScreenerSettingRequestToJSON(json: any): UpdateScreenerSettingRequest {
    return UpdateScreenerSettingRequestToJSONTyped(json, false);
}

export function UpdateScreenerSettingRequestToJSONTyped(value?: UpdateScreenerSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

